import React, { useContext } from 'react';
import { getIsDateWithinXDays } from '@wix/da-ds/pkg/Time/functions';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreMenuItem from '../../../_partials/CoreMenuItem';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
import userMenuStyles from '../UserMenuDesktop/UserMenuDesktop.scss';
export function useBuyCoreItem() {
    const { hasCoreMembership, coreLevel, coreExpires } = useContext(SessionContext);
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    const isUpgradableCoreLevel = coreLevel === 'core_access' || coreLevel === 'core_plus';
    const coreExpiresIn30 = coreExpires && getIsDateWithinXDays(coreExpires, 30);
    const upgradableAndExpiringCore = isUpgradableCoreLevel && coreExpiresIn30;
    const linkUrl = !hasCoreMembership || upgradableAndExpiringCore ? Url.coreMembershipLink() : Url.account();
    return {
        key: 'buy-core',
        label: /*#__PURE__*/ React.createElement(CoreMenuItem, {
            className: userMenuStyles['two-side-label'],
            hasCoreMembership: hasCoreMembership,
            coreLevel: coreLevel,
            coreExpires: coreExpires
        }),
        link: linkUrl,
        biData: BiData({
            evid: 702,
            link_url: linkUrl,
            menu_item: hasCoreMembership ? 'my_core' : 'core_membership',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}
